/*  This is the price toggle class function component. This component uses state class to toggle between two radio buttons
 * and brings in two child components (monthly-pricing.js & annual-pricing.js) which display the pricing data and styling.
 * This conmponent is a parent of the Monthly and Annual child components. This this file is for the mobile implementation which utilizes and is
 * the parent of the tab.js and tabs.js components.
 * inspired from:
 * https:/stackoverflowcomquestions51430364what-is-the-most-efficient-way-to-toggle-between-two-components-react-js
 *
 */

/* [SK] All the modal content for mobile view is located within this file due to the fact the Netlify
 * requires that all forms be visible to the DOM during the inital build.
 */

import React from 'react';
import { Row, Col } from 'react-bootstrap';
import Monthly from './monthly-pricing-mobile';
import Annual from './annual-pricing-mobile';
import PricingPageStyle from './pricing-page.module.scss';

class PricingPlansMobile extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      display: 'first',
    };
  }

  changeDisplay = () => {
    let { display } = this.state;
    this.setState({ display: display === 'first' ? 'second' : 'first' });
  };

  renderInner() {
    let { display } = this.state;

    if (display === 'first') {
      return <Annual />;
    } else if (display === 'second') {
      return <Monthly />;
    }
  }

  render() {
    return (
      <div
        className={` ${PricingPageStyle.pricingMobileSection} ${PricingPageStyle.sectionDiv} `}
      >
        <Row className={PricingPageStyle.pricingPlansMobile}>
          <Col md={6} className={PricingPageStyle.pricingPlansMobileCol1}>
            <input
              className={PricingPageStyle.radioMobile}
              type='radio'
              aria-label='Annual Pricing'
              value='Annual'
              name='payment'
              onChange={this.changeDisplay}
              defaultChecked={true}
            />
            <h3 className={PricingPageStyle.pricingTerm}>
              Annual Term <strong>(Save 10%)</strong>
            </h3>
          </Col>
          <Col md={6} className={PricingPageStyle.pricingPlansMobileCol2}>
            <input
              className={PricingPageStyle.radioMobile}
              type='radio'
              aria-label='Monthly Pricing'
              value='Monthly'
              name='payment'
              onChange={this.changeDisplay}
            />
            <h3 className={PricingPageStyle.pricingTerm}>Monthly Term</h3>
          </Col>
        </Row>
        {this.renderInner()}
      </div>
    );
  }
}

export default PricingPlansMobile;
